// if (!customElements.get('product-modal')) {
//   customElements.define(
//     'product-modal',
//     class ProductModal extends ModalDialog {
//       constructor() {
//         super();
//       }

//       hide() {
//         super.hide();
//       }

//       show(opener) {
//         super.show(opener);
//         this.showActiveMedia();
//       }

//       showActiveMedia() {
//         this.querySelectorAll(
//           `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
//         ).forEach((element) => {
//           element.classList.remove('active');
//         });
//         const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
//         const activeMediaTemplate = activeMedia.querySelector('template');
//         const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
//         activeMedia.classList.add('active');
//         activeMedia.scrollIntoView();

//         const container = this.querySelector('[role="document"]');
//         container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

//         if (
//           activeMedia.nodeName == 'DEFERRED-MEDIA' &&
//           activeMediaContent &&
//           activeMediaContent.querySelector('.js-youtube')
//         )
//           activeMedia.loadContent();
//       }
//     }
//   );
// }

if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.splide = null; // ✅ ADD
      }

      connectedCallback() {
        super.connectedCallback?.();
        this.initSplide(); // ✅ ADD
      }

      initSplide() {
        const slider = this.querySelector('.product-media-modal-splide');
        if (!slider || this.splide) return;

        this.splide = new Splide(slider, {
          type: 'loop',
          perPage: 1,
          gap: '1rem',
          arrows: true,
          pagination: false,
          interval: 3500,
          pauseOnHover: true,
          pauseOnFocus: false,
        }).mount();
      }

      goToActiveSlide() {
        if (!this.splide) return;

        const slides = this.splide.Components.Elements.slides;

        const index = slides.findIndex(slide =>
          slide.classList.contains('is-active-custom')
        );
        
        console.log("index------", index);

        if (index !== -1) {
          this.splide.go(index);
        }
      }


      hide() {
        super.hide();
      }

      show(opener) {
        this.opener = opener;
        
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (this.opener.hasAttribute('data-media-id')) {
          const mediaId = this.opener.getAttribute('data-media-id');
          const modal_opener = this.opener.closest("modal-opener");
          const modal = document.querySelector(modal_opener.getAttribute('data-modal'));
          const slides = modal.querySelectorAll('.splide__slide');

          console.log("slides----", slides, mediaId);

          slides.forEach(slide => {
            slide.classList.remove('is-active-custom');

            if (slide.getAttribute('data-media-id') === mediaId) {
              slide.classList.add('is-active-custom');
            }
          });
        }
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        );

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;

        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft =
          (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
        if (this.splide) {
          // Remove any previous refresh listener to prevent duplicates
          this.splide.off('refresh');

          // Add one refresh listener
          this.splide.on('refresh', () => {
            this.goToActiveSlide();
          });

          // Refresh Splide
          this.splide.refresh();
        }

      }
    }
  );
}

